import React from 'react';
import {IconButton, styled} from '@mui/material';
import {CheckBox, CheckBoxOutlineBlank} from '@mui/icons-material';
import TaskPriority from '../TaskPriority';
import TaskNotes from '../TaskNotes';
import {date, dateTime} from '@management-ui/core';

const Holder = styled('li')(({theme}) => ({
  alignItems: 'center',
  display: 'flex',
  gap: theme.spacing(2),
}));

const Details = styled('div')(({theme}) => ({
  alignItems: 'center',
  cursor: 'pointer',
  display: 'flex',
  flex: 1,
  gap: theme.spacing(1),
}));

const Task = ({task, onSelect, onToggle, showDeadline = false, showCompleted = false}) => (
  <Holder>
    {onToggle ? (
      <IconButton
        disabled={!!task.completed_at}
        onClick={() => onToggle(task)}>
        {task.completed_at ? <CheckBox/> : <CheckBoxOutlineBlank/>}
      </IconButton>
    ) : null}
    <Details onClick={() => onSelect(task)}>
      <TaskPriority task={task}/>
      {task.notes !== undefined ? <TaskNotes task={task}/> : null}
      <span>
        {task.title}
        {showDeadline ? <i>&nbsp;(Deadline: {date(task.deadline)})</i> : null}
        {showCompleted && task.completed_at ? <i>&nbsp;(Completed: {dateTime(task.completed_at)})</i> : null}
      </span>
    </Details>
  </Holder>
)

export default Task;